import React from 'react';

/**
 * DividerBlock — a horizontal separator line.
 */
export const DividerBlock = () => (
  <div className="divider-block">
    <hr className="divider-line" />
  </div>
);
